/**
 * Pillar 6 — Inbox status pill.
 *
 * Construction-language only labels:
 *   New · Viewed · Acknowledged · Needs Clarification · Field Conflict · Complete
 */
import React from "react";

const STYLES = {
  new: {
    label: "New",
    fg: "#fef3c7",
    bg: "rgba(245, 158, 11, 0.20)",
    border: "rgba(245, 158, 11, 0.6)",
  },
  viewed: {
    label: "Viewed",
    fg: "#cffafe",
    bg: "rgba(56, 189, 248, 0.18)",
    border: "rgba(56, 189, 248, 0.55)",
  },
  acknowledged: {
    label: "Acknowledged",
    fg: "#bbf7d0",
    bg: "rgba(34, 197, 94, 0.18)",
    border: "rgba(34, 197, 94, 0.55)",
  },
  needs_clarification: {
    label: "Needs Clarification",
    fg: "#fde68a",
    bg: "rgba(234, 179, 8, 0.18)",
    border: "rgba(234, 179, 8, 0.6)",
  },
  field_conflict: {
    label: "Field Conflict",
    fg: "#fecaca",
    bg: "rgba(220, 38, 38, 0.18)",
    border: "rgba(220, 38, 38, 0.6)",
  },
  complete: {
    label: "Complete",
    fg: "var(--fop-text-3)",
    bg: "transparent",
    border: "var(--fop-border)",
  },
};

export default function StatusPill({ status = "new", testid }) {
  const cfg = STYLES[status] || STYLES.new;
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-mono uppercase tracking-wider shrink-0"
      style={{
        color: cfg.fg,
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
      }}
      data-testid={testid}
      data-status={status}
    >
      {cfg.label}
    </span>
  );
}
